/* eslint-disable */
import axios from 'axios';
import { stat } from 'fs';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    createQuizData: {},
    getQuizData:{},
    getQuizDetailsByIdData:{},
    updateQuizData:{},
    removeQuizData:{},
    getQuizQuesData:{},
    createQuizQuesData:{},
    getQuizQuesDetailsByIdData:{},
    updateQuizQuesDetailsByIdData:{},
    removeQuizQuesData:{},
    getQuizzesHistoryData:{},
    trashQuizData:{},
    getImgforQuizData:{},
    getContestQuizData:{},
    getUserQuizHistoryState:{},
    getFeedbackOfContestState:{},
    getRewardPointsDetailsByIdState:{},
    getSectionDetailsByIdForQuizState:{},
    getSectionListForQuizState:{},
    getSectionConfigForQuizState:{},
    getSectionConfigForQuizByIdState:{},
    getSectionConfigForQuizzesState:{}
  },
  mutations: {
    createQuizMutation(state, response) {
      state.createQuizData = response;
    },
    getQuizMutation(state, response) {
      state.getQuizData = response;
    },
    getContestQuizMutation(state, response) {
      state.getContestQuizData = response;
    },
    trashQuizMutation(state, response) {
      state.trashQuizData = response;
    },
    getQuizDetailsByIdMutation(state, response) {
      state.getQuizDetailsByIdData = response;
    },
    updateQuizMutation(state, response) {
      state.updateQuizData = response;
    },
    removeQuizMutation(state, response) {
      state.removeQuizData = response;
    },
    getQuizQuesMutation(state, response){
      state.getQuizQuesData = response;
    },
    createQuizQuesMutation(state, response){
      state.createQuizQuesData = response;
    },
    getQuizQuesByIdMutation(state, response){
      state.getQuizQuesDetailsByIdData = response;
    },
    updateQuizQuesByIdMutation(state, response){
      state.updateQuizQuesDetailsByIdData = response;
    },
    removeQuizQuesMutation(state, response) {
      state.removeQuizQuesData = response;
    },
    getQuizzesHistoryMutation(state, response){
      state.getQuizzesHistoryData = response
    },
    getImgforQuizMutation(state, response){
      state.getImgforQuizData = response
    },
    getUserQuizHistoryMutations(state, response){
      state.getUserQuizHistoryState = response
    },
    getFeedbackOfContestMutations(state, response){
      state.getFeedbackOfContestState = response
    },
    getRewardPointsDetailsByIdMutations(state, response){
      state.getRewardPointsDetailsByIdState = response
    },
    getSectionDetailsByIdForQuizMuatation(state, response){
      state.getSectionDetailsByIdForQuizState = response
    },
    getSectionListForQuizMuatation(state, response){
      state.getSectionListForQuizState = response
    },
    getSectionConfigForQuizMuatation(state, response){
      state.getSectionConfigForQuizState = response
    },
    getSectionConfigForQuizzesMuatation(state, response){
      state.getSectionConfigForQuizzesState = response
    },
    getSectionConfigForQuizByIdMuatation(state, response){
      state.getSectionConfigForQuizByIdState = response
    },
  },
  actions: {
    // Get Quiz List
    getQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz/').then((response) => {
          context.commit('getQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz List By COurse Id
    getQuizByCourseFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz/?course=' + payload.id).then((response) => {
          context.commit('getQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz List By Category Id
    getQuizByCategoryFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz/' + '?category=' + payload.id + '&quiz_for=' + 1).then((response) => {
          context.commit('getQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get COntest Quiz List By Category Id
    getContestQuizByCategoryFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz/' + '?category=' + payload.id + '&quiz_for=' + 3).then((response) => {
          context.commit('getContestQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Trash Quiz List
    trashQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz/?is_deleted=1').then((response) => {
          context.commit('trashQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Details By Id
    getQuizDetailsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz/' + payload.id + '/').then((response) => {
          context.commit('getQuizDetailsByIdMutation', response.data.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Create New Quiz
    createQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/quiz/', payload).then((response) => {
          context.commit('createQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Quiz By ID
    updateQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/quiz/' + payload.data.id + '/', payload.data.data).then((response) => {
          context.commit('updateQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Remove Quiz
    removeQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/quiz/' + payload.id + '/').then((response) => {
          context.commit('removeQuizMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Question List
    getQuizQuesFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/question/').then((response) => {
          context.commit('getQuizQuesMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Create Quiz Question List
    createQuizQuesFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/question/', payload).then((response) => {
          // context.commit(' createQuizQuesMutation', response);
          // debugger
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Question Details By ID
    getQuizQueDetailssByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/question/' + payload.id + '/').then((response) => {
          context.commit('getQuizQuesByIdMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Quiz Question Details By ID
    updateQuizQueDetailssByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/question/' + payload.data.id + '/', payload.data.data).then((response) => {
          context.commit('updateQuizQuesByIdMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Quiz OPtion Details By ID
    updateQuizQueOptionByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/option/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Remove Quiz Question Details By ID
    removeQuizQuesFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/question/' + payload.id + '/').then((response) => {
          context.commit('removeQuizQuesMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz History List
    getQuizzesAllHistory(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/user-quiz-history/?quiz=' + payload.id).then((response) => {
          context.commit('getQuizzesHistoryMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz History List
    getQuizzesHistory(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/user-quiz-history/?course=' + payload.id).then((response) => {
          context.commit('getQuizzesHistoryMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Create Quiz Images List
    createImgforQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/image-gallery/admin/', payload).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Quiz Images List
    getImgforQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/image-gallery/admin/?page_size=5').then((response) => {
          context.commit('getImgforQuizMutation', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Update user attempted history
    updateUserAttemptedHistoryFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/user-quiz/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Get User Quiz History List
    getUserQuizHistoryByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/user-quiz-history/?user=' + payload.id ).then((response) => {
          context.commit('getUserQuizHistoryMutations', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Get User Feedback Of Contest
    getFeedbackOfContestFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/account/admin/feedback/?entity_id=' + payload.id ).then((response) => {
          context.commit('getFeedbackOfContestMutations', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Quiz Reward points url
   createQuizRewardPointsFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/quiz_rewards/', payload).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Quiz Reward points url
   getQuizRewardPointsDetailsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz_rewards/' + payload.id + '/').then((response) => {
          context.commit('getRewardPointsDetailsByIdMutations', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Quiz Reward points url
   updateQuizRewardPointsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/quiz_rewards/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Quiz Reward points url
   removeQuizRewardPointsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/quiz_rewards/' + payload.id + '/').then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Quiz Reward points url
    updateIndexQuizRewardPointsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/quiz_rewards/' + payload.data.id + /index/, payload.data.data).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section List Get url
    getSectionListForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz_section/?quiz=' + payload.id + '&page_size=5').then((response) => {
          context.commit('getSectionListForQuizMuatation', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    }, 
    // Quiz Section Created url
    createdSectionForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/quiz_section/', payload).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Get Details By Id url
    getSectionDetailsByIdForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz_section/' + payload.id + '/').then((response) => {
          context.commit('getSectionDetailsByIdForQuizMuatation', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Update Details By Id url
    updateSectionDetailsByIdForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/quiz_section/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },   
    // Quiz Section Delete Details By Id url
    removeSectionDetailsByIdForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/quiz_section/' + payload.id + '/').then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Conifg Created url
    createdSectionConfigForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/quizzes/admin/section_config/', payload).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Conifg List Get url
    getSectionConfigForQuizzesFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/quiz_section/?quiz=' + payload.id + '&page_size=5').then((response) => {
          context.commit('getSectionConfigForQuizzesMuatation', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Conifg List Get url
    getSectionConfigForQuizFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/section_config/?quiz_section=' + payload.id + '&page_size=5').then((response) => {
          context.commit('getSectionConfigForQuizMuatation', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Conifg List By ID Get url
    getSectionConfigForQuizByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/section_config/' + payload.id).then((response) => {
          context.commit('getSectionConfigForQuizByIdMuatation', response.data);
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },  
    // Quiz Section Conifg Details Update url
    updateSectionConfigForQuizByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/quizzes/admin/section_config/' + payload.data.id + '/', payload.data.data).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
    // Quiz Section Conifg Details Update url
    removeSectionConfigForQuizByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/quizzes/admin/section_config/' + payload.id).then((response) => {
          resolve(response);
        }).catch(function (error) {
            reject(error);
          });
      })
    },
  },
  getters: {
    createQuizDataState: state => state.createQuizData,
    getQuizDataState: state => state.getQuizData,
    getQuizDetailsByIdDataState: state => state.getQuizDetailsByIdData,
    updateQuizDataState: state => state.updateQuizData,
    removeQuizDataState: state => state.removeQuizData,
    getQuizQuesDataState: state => state.getQuizQuesData,
    createQuizQuesDataState: state => state.createQuizQuesData,
    getQuizQuesDetailsByIdDataState: state => state.getQuizQuesDetailsByIdData,
    updateQuizQuesDetailsByIdDataState: state => state.updateQuizQuesDetailsByIdData,
    removeQuizQuesDataState: state => state.removeQuizQuesData,
    getQuizzesHistoryDataState: state => state.getQuizzesHistoryData,
    trashQuizDataState: state => state.trashQuizData,
    getImgforQuizDataState: state => state.getImgforQuizData,
    getContestQuizDataState: state => state.getContestQuizData,
    getUserQuizHistoryGetters: state => state.getUserQuizHistoryState,
    getFeedbackOfContestGetters:state => state.getFeedbackOfContestState,
    getRewardPointsDetailsByIdGetters: state => state.getRewardPointsDetailsByIdState,
    getSectionDetailsByIdForQuizGetters: state => state.getSectionDetailsByIdForQuizState,
    getSectionListForQuizGetters: state =>  state.getSectionListForQuizState,
    getSectionConfigForQuizGetters:state => state.getSectionConfigForQuizState,
    getSectionConfigForQuizByIdGetters:state => state.getSectionConfigForQuizByIdState,
    getSectionConfigForQuizzesGetters:state => state.getSectionConfigForQuizzesState
  }
}